
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1702"}},[_c('path',{attrs:{"data-name":"Rectangle 2407","fill":"none","d":"M.001 0h25v20h-25z"}}),_c('path',{attrs:{"data-name":"Path 1053","d":"M24 0H1a1 1 0 00-1 1v18a1 1 0 001 1h23a1 1 0 001-1V1a1 1 0 00-1-1zm-1 13.859a3.981 3.981 0 010-7.717zM12.5 11.5A1.5 1.5 0 1114 10a1.5 1.5 0 01-1.5 1.5zM2 6.143a3.979 3.979 0 010 7.714zm0 9.765A5.99 5.99 0 002 4.093V1.999h9.5v4.51a.912.912 0 00.03.147 3.476 3.476 0 000 6.689.912.912 0 00-.03.147v4.509H2zm11.5 2.093v-4.509a.91.91 0 00-.029-.147 3.476 3.476 0 000-6.689.91.91 0 00.029-.147v-4.51H23v2.092a5.992 5.992 0 000 11.819v2.091z","fill":"#3c3c3c"}})])])
          )
        }
      }
    